// @ts-expect-error module not typed
import { getFileMetadata } from 'conversations-internal-schema/resolved-attachment/operators/resolvedAttachmentGetters';
import { PureComponent } from 'react';
import FileAttachmentTile from './FileAttachmentTile';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
class FileAttachmentsFooter extends PureComponent {
  render() {
    const {
      fileAttachments,
      genericChannelId
    } = this.props;
    return /*#__PURE__*/_jsx(View, {
      "data-test-id": "file-attachments-footer",
      cursor: "pointer",
      display: "block",
      children: fileAttachments.map((fileAttachment, index) => {
        const fileMetadata = getFileMetadata(fileAttachment);
        return fileMetadata && /*#__PURE__*/_jsx(FileAttachmentTile, {
          fileMetadata: fileMetadata,
          genericChannelId: genericChannelId
        }, index);
      })
    });
  }
}
FileAttachmentsFooter.displayName = 'FileAttachmentsFooter';
export default FileAttachmentsFooter;